// Autoplay resilience helpers — sessions must always begin automatically.
// unlockAudio() is called inside real user gestures (Begin / Play buttons) so
// the platform marks the page as audio-activated before any session screen
// needs to start sound on its own.

const SILENT_WAV =
  "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQQAAAAAAA==";

let _unlockEl = null;

export function unlockAudio() {
  try {
    if (!_unlockEl) {
      _unlockEl = new Audio(SILENT_WAV);
      _unlockEl.setAttribute("playsinline", "");
      _unlockEl.volume = 0.001;
    }
    const p = _unlockEl.play();
    if (p && p.then) p.then(() => { try { _unlockEl.pause(); _unlockEl.currentTime = 0; } catch (e) { /* ignore */ } }).catch(() => { /* ignore */ });
  } catch (e) { /* ignore */ }
}

// Silent self-healing: if a play() was still blocked, retry it on the very
// next interaction anywhere on the page — no message, no visible interruption.
export function retryOnNextGesture(fn) {
  const handler = () => {
    document.removeEventListener("pointerdown", handler, true);
    document.removeEventListener("keydown", handler, true);
    try { fn(); } catch (e) { /* ignore */ }
  };
  document.addEventListener("pointerdown", handler, true);
  document.addEventListener("keydown", handler, true);
}
